//隐私设置页面
import BaseScreen from "../BaseScreen";
import NavBar from "../../components/NavBar";
import { CommonSetting } from "../../components/setting/CommonSetting";
import { MainNavProps } from "../navigation/main/MainParamList";
import { useEffect, useState } from "react";
import { useStore } from "../../store/UserStore";
import { postJson } from "../../net/http";
import {
  Str_AccountPrivacy,
  Str_BlackManager,
  Str_PrivacySetting,
} from "../../language/string_res";
import { StyleSheet, View } from "react-native";

export const PrivacySetting = ({
  navigation,
}: MainNavProps<"PrivacySetting">) => {
  const { state, dispatch } = useStore();
  const [privacy, setPrivacy] = useState(state?.user?.privacy === "1");
  function privacySet(newValue: boolean) {
    const privacyStr = newValue ? "1" : "0";
    const body = { privacy: privacyStr };
    postJson<any>(`/v1/sdk/user/profile/set`, { body: body, debug: true }).then(
      (res) => {
        if (res.code === 0) {
          if (state?.user) {
            state.user.privacy = body.privacy;
            dispatch({
              type: "UPDATE_USER_INFO",
              payload: state.user,
            });
            setPrivacy(newValue);
          }
        } else {
          setTimeout(() => {
            setPrivacy(!newValue);
          }, 300);
        }
      }
    );
  }

  return (
    <BaseScreen>
      <NavBar title={Str_PrivacySetting} showBack={false} />
      <View style={styles.contentContainer}>
        <CommonSetting
          style={{ marginTop: 12, borderRadius: 0 }}
          itemOption={[
            // {
            //     text: Str_OpenNotify, rightType: "Switch",
            //     setIsEnabled: setOpenNotify,
            //     switchIsEnabled: openNotify
            // },
            {
              text: Str_AccountPrivacy,
              rightType: "Switch",
              switchChange: (newValue) => privacySet(newValue),
              switchIsEnabled: privacy,
              setIsEnabled: setPrivacy,
            },
            {
              text: Str_BlackManager,
              rightType: "Back",
              onClick: () => {
                navigation.navigate("BlackList");
              },
            },
          ]}
        />
      </View>
    </BaseScreen>
  );
};

const styles = StyleSheet.create({
  contentContainer: {
    width: "100%",
    maxWidth: 800,
    alignSelf: "center",
    paddingHorizontal: 20,
    marginTop: 40,
    backgroundColor: "white",
    borderRadius: 16,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 8,
    elevation: 4,
    paddingTop: 8,
    paddingBottom: 8,
  },
});
